"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = exports.Store = void 0;
var Store;
(function (Store) {
    Store["DE"] = "de";
    Store["NL"] = "nl";
    Store["ES"] = "es";
    Store["AT"] = "at";
    Store["US"] = "us";
    Store["BUSINESS"] = "business";
    Store["BUSINESS_NL"] = "business_nl";
    Store["BUSINESS_ES"] = "business_es";
    Store["BUSINESS_AT"] = "business_at";
    Store["BUSINESS_US"] = "business_us";
})(Store || (exports.Store = Store = {}));
var Locale;
(function (Locale) {
    Locale["EN"] = "en";
    Locale["DE"] = "de";
    Locale["NL"] = "nl";
    Locale["ES"] = "es";
})(Locale || (exports.Locale = Locale = {}));
//# sourceMappingURL=common.js.map